import React from "react";
import PropTypes from "prop-types";

export function BoxIcon(props) {
	let attributes = {};

	if (props.type === "color") {
		attributes.style = { backgroundColor: props.color };
	} else {
		attributes.style = { backgroundImage: `url("${props.url}")` };
	}

	return <div className={`boxIcon ${props.type}`} {...attributes}></div>;
}

BoxIcon.propTypes = {
	type: PropTypes.oneOf(["color", "img"]),
	color: PropTypes.string,
	url: PropTypes.string,
};

BoxIcon.defaultProps = {
	color: "#fff",
	url: "",
	type: "color",
};

export default BoxIcon;
